import { render, staticRenderFns } from "./OrderingBenefitsClub.vue?vue&type=template&id=dd5c2f6a&scoped=true"
import script from "./OrderingBenefitsClub.vue?vue&type=script&lang=js"
export * from "./OrderingBenefitsClub.vue?vue&type=script&lang=js"
import style0 from "./OrderingBenefitsClub.vue?vue&type=style&index=0&id=dd5c2f6a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5c2f6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd5c2f6a')) {
      api.createRecord('dd5c2f6a', component.options)
    } else {
      api.reload('dd5c2f6a', component.options)
    }
    module.hot.accept("./OrderingBenefitsClub.vue?vue&type=template&id=dd5c2f6a&scoped=true", function () {
      api.rerender('dd5c2f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/PreviewArea/OrderingBenefitsClub.vue"
export default component.exports